export default "skymp5-front/974e57d8f268ac8708281641281ca5d9.png";